"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookiesMenuPanelIds = exports.CookiesBannerIds = void 0;
exports.CookiesBannerIds = {
    cookiesBannerButton: 'cookies-banner_button',
    cookiesBannerCloseButton: 'cookies-banner_close-button'
};
exports.CookiesMenuPanelIds = {
    CookiesMenuPanelAcceptButton: 'cookie-menu-panel_accept-all-cookies-button',
    CookiesMenuPanelRejectButton: 'cookie-menu-panel_reject-all-cookies-button',
    CookiesMenuPanelCustomAcceptButton: 'cookie-menu-panel_accept-custom-cookies-button'
};
